import React from 'react';
import css from './SearchFilterContent.module.css';
import {
  DatePickerField,
  DropdownField,
  H3,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
} from '../../../../../../core';
import { LocationOptions } from '../../../../../../utils';

export interface SearchFilterContentProps {
  date: Date | null | undefined;
  locationId: string;
  showLocationOptions: boolean;
  locationList: LocationOptions[];
  filterChanged: (date: Date | null | undefined, locationId: string) => void;
}

const SearchFilterContent: React.FC<SearchFilterContentProps> = (
  props: SearchFilterContentProps
) => {
  const onDateChange = (value: Date | null | undefined) => {
    props.filterChanged(value, props.locationId);
  };

  const onLocationPicked = (item: string) => {
    props.filterChanged(props.date, item);
  };

  return (
    <StackedColumn spacing={StackedColumnSpacing.Tight}>
      <H3 text="Refine search" />
      <StackedRow>
        <div className={css.dateFieldWrapper}>
          <DatePickerField
            label="Select a date (MM/DD/YYYY)"
            onDateChange={onDateChange}
            value={props.date}
          />
        </div>
        {props.showLocationOptions ? (
          <div className={css.locationFieldWrapper}>
            <DropdownField
              label="Location"
              selectedValue={props.locationId}
              options={props.locationList.map((location) => {
                return {
                  text: location.label,
                  value: location.value,
                };
              })}
              onItemPicked={onLocationPicked}
            />
          </div>
        ) : null}
      </StackedRow>
    </StackedColumn>
  );
};

export default SearchFilterContent;
